module.exports = __webpack_public_path__ + "static/img/login-samu-03.4c21672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-samu-03.png
// module id = km9n
// module chunks = 4